export const UPCOMING_COLLECTION_TYPENAME = "UpcomingCollection";